import React, { useState } from "react";
import { getScaffaliForMagazzino, SETTORI } from "@/lib/api";
import { ChevronDown } from "lucide-react";

export const PositionPicker = ({ settore, scaffale, magazzino = "Vasto", onChange }) => {
  const [openSettore, setOpenSettore] = useState(false);
  const scaffali = getScaffaliForMagazzino(magazzino);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label className="block text-xs font-black uppercase tracking-widest mb-2">
          Settore (1–121)
        </label>
        <div className="relative">
          <button
            type="button"
            data-testid="position-settore-button"
            onClick={() => setOpenSettore((v) => !v)}
            className="w-full bg-white border-2 border-black p-3 font-mono-data font-bold text-left flex items-center justify-between hover:bg-black hover:text-white transition-colors"
          >
            <span>{settore ? `Settore ${settore}` : "Seleziona settore"}</span>
            <ChevronDown className="w-4 h-4" strokeWidth={3} />
          </button>
          {openSettore && (
            <div
              className="absolute z-30 mt-1 w-full bg-white border-2 border-black brutal-shadow max-h-72 overflow-auto"
              data-testid="position-settore-dropdown"
            >
              <div className="grid grid-cols-6 sm:grid-cols-8 gap-0">
                {SETTORI.map((n) => (
                  <button
                    key={n}
                    type="button"
                    data-testid={`settore-option-${n}`}
                    onClick={() => {
                      onChange({ settore: n, scaffale: scaffale || "A" });
                      setOpenSettore(false);
                    }}
                    className={`p-2 font-mono-data text-xs font-bold border border-black/40 hover:bg-[#E60000] hover:text-white transition-colors ${
                      settore === n ? "bg-black text-white" : "bg-white text-black"
                    }`}
                  >
                    {n}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div>
        <label className="block text-xs font-black uppercase tracking-widest mb-2">
          Scaffale
        </label>
        <div className="grid grid-cols-3 gap-2">
          {scaffali.map((s) => (
            <button
              key={s}
              type="button"
              data-testid={`scaffale-${s}`}
              onClick={() => onChange({ settore, scaffale: s })}
              className={`border-2 border-black p-3 font-display font-black text-2xl transition-colors ${
                scaffale === s
                  ? "bg-[#E60000] text-white"
                  : "bg-white text-black hover:bg-black hover:text-white"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PositionPicker;
